import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import styled from "@emotion/styled";
import { FaArrowRight, FaArrowLeft } from "react-icons/fa";
import { ClearedStyleHref } from "@modules/Components";
import { IoIosArrowForward } from "react-icons/io";
import { useDispatch } from "react-redux";
import { initAppBrowser } from "@actions/initApp";

const LeftSide = styled.div`
  position: relative;
  background-color: #ecf8fd;
  grid-column: 1/3;
  grid-row: 1/2;

  @media (max-width: 1015px) {
    display: none;
  }
`;

const RightSide = styled.div`
  grid-column: 2/4;
  grid-row: 1/3;
  height: 100%;

  @media (max-width: 575px) {
    display: none;
  }
`;

const ImageContainer = styled.div`
  overflow: hidden;
  height: 100%;
  border-radius: 0px 0px 0px 400px;
  position: relative;

  @media (max-width: 1400px) {
    border-radius: 0px 0px 0px 325px;
  }
  @media (max-width: 1350px) {
    border-radius: 0px 0px 0px 305px;
  }
  @media (max-width: 1015px) {
    border-radius: 0px 0px 0px 250px;
  }
`;

const Image = styled.img`
  width: 211%;
  border-radius: 0px 0px 0px 460px;
  position: absolute;
  top: -388px;
  left: -449px;
  z-index: 1;

  @media (max-width: 1800px) {
    width: 213%;
    top: -311px;
    left: -411px;
  }
  @media (max-width: 1700px) {
    width: 217%;
    top: -314px;
    left: -442px;
  }
  @media (max-width: 1600px) {
    width: 236%;
  }
  @media (max-width: 1500px) {
    width: 254%;
    top: -295px;
    left: -505px;
  }
  @media (max-width: 1350px) {
    top: -267px;
    left: -440px;
  }
  @media (max-width: 1200px) {
    left: -393px;
  }
  @media (max-width: 1015px) {
    left: -396px;
    top: -185px;
    width: 281%;
  }
  @media (max-width: 900px) {
    display: none;
  }
`;

const TabletMainImage = styled.img`
  @media (min-width: 901px) {
    display: none;
  }

  position: absolute;
  left: -470px;
  top: -213px;
  width: 369%;

  @media (max-width: 825px) {
    left: -480px;
    top: -213px;
    width: 398%;
  }
  @media (max-width: 767px) {
    left: -506px;
    top: -245px;
    width: 528%;
  }
  @media (max-width: 720px) {
    left: -506px;
    top: -228px;
    width: 556%;
  }
  @media (max-width: 690px) {
    left: -446px;
    top: -216px;
    width: 562%;
  }
  @media (max-width: 620px) {
    left: -467px;
    top: -216px;
    width: 619%;
  }
`;

const HeaderText = styled.h1`
  font-size: 58px;
  margin-bottom: 57px;
  line-height: 1.25;
  color: #1f2021;
  width: 532px;

  @media (max-width: 1400px) {
    font-size: 50px;
  }
  @media (max-width: 1015px) {
    width: 100%;
    font-size: 48px;
    max-width: 305px;
    margin-bottom: 33px;
  }
  @media (max-width: 750px) {
    margin: 0 auto;
    margin-bottom: 33px;
  }
  @media (max-width: 340px) {
    font-size: 43px;
  }
`;

const HeaderP = styled.div`
  font-size: 18px;
  width: 87%;
  line-height: 2;
  color: #777984;
  width: 532px;

  @media (max-width: 1015px) {
    width: auto;
    max-width: 305px;
  }
  @media (max-width: 750px) {
    margin: 0 auto;
  }
`;

const InnerHeader = styled.div`
  display: grid;
  grid-template-columns: 52% 10% 38%;
  grid-template-rows: 650px 100px;

  @media (max-width: 1400px) {
    grid-template-rows: 575px 86px;
  }
  @media (max-width: 1350px) {
    grid-template-rows: 575px 68px;
  }
  @media (max-width: 1015px) {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr;
  }
  @media (max-width: 900px) {
    grid-template-columns: 1.4fr 1fr;
  }
  @media (max-width: 767px) {
    grid-template-columns: 1.9fr 1fr;
  }
`;

const LeftImage = styled.img`
  position: absolute;
  top: 0;
  height: 82%;

  @media (max-width: 1700px) {
    height: 72%;
  }
  @media (max-width: 1400px) {
    height: 67%;
  }
  @media (max-width: 1015px) {
    display: none;
  }
`;

const RightImage = styled.img`
  position: absolute;
  right: 0;
  top: 264px;
  width: 223px;

  @media (max-width: 1700px) {
    top: 232px;
    width: 214px;
  }
  @media (max-width: 1400px) {
    top: 190px;
    width: 204px;
  }
  @media (max-width: 1015px) {
    display: none;
  }
`;

const TabletImage = styled.img`
  @media (min-width: 1016px) {
    display: none;
  }

  position: absolute;
  top: 0;
  left: -70px;
  max-width: 390px;

  @media (max-width: 575px) {
    max-width: 337px;
  }
`;

const AbsoluteImages = styled.div`
  position: relative;
  grid-column: 1/2;
  grid-row: 1/2;
  z-index: 1;

  @media (max-width: 1015px) {
    z-index: 2;
  }
`;

const HeaderTextContainer = styled.div`
  grid-row: 1/2;
  z-index: 2;
  grid-column: 1/4;
  margin: 0 auto;
  text-align: left;
  margin-top: 163px;

  @media (max-width: 1400px) {
    margin-top: 124px;
  }
  @media (max-width: 1015px) {
    grid-column: 1/2;
    width: 100%;
    background-color: #ecf8fd;
    margin: 0 auto;
    height: 664px;
    padding-top: 130px;
    text-align: center;
    border-radius: 0px 0px 250px 0px;
    padding-left: 13%;
  }
  @media (max-width: 900px) {
    padding-left: 17%;
  }
  @media (max-width: 750px) {
    padding-left: 0;
  }
  @media (max-width: 575px) {
    grid-column: 1/3;
    border-radius: 0px 0px 0px 150px;
    height: 584px;
    padding-top: 112px;
  }
`;

const OpeningStatement = styled.div`
  max-width: 969px;
  margin: 0 auto;
  margin-top: 126px;
  text-align: center;

  @media (max-width: 1400px) {
    margin-top: 95px;
  }
  @media (max-width: 1015px) {
    width: 95%;
  }
  @media (max-width: 724px) {
    width: 90%;
  }
`;

const CurvedImageContainer = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 0px 0px 0px 25px;
  background-color: #ecf8fd;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  margin-bottom: 50px;
`;

const CurvedImage = styled.img`
  filter: drop-shadow(0px 10px 10px rgba(18, 178, 234, 0.5));
`;

const OpeningStatementP = styled.div`
  font-size: 18px;
  line-height: 2;
  color: #777984;
  margin-bottom: 35px;
`;

const Recognition = styled.div`
  display: grid;
  grid-template-columns: 1fr 1.3fr;
  margin-top: 162px;
  grid-gap: 71px;

  @media (max-width: 1450px) {
    grid-template-columns: 1fr 1.1fr;
  }
  @media (max-width: 1015px) {
    display: block;
    text-align: center;
    margin-top: 115px;
  }
`;

const RecognitionLeft = styled.div`
  margin-top: 73px;
`;

const RecognitionRight = styled.div`
  @media (max-width: 1015px) {
    margin-top: 60px;
  }
`;

const RecognitionImage = styled.img`
  width: 100%;

  @media (max-width: 1015px) {
    max-width: 700px;
  }
`;

const RecognitionHeader = styled.div`
  font-size: 30px;
  line-height: 1.5;
  color: #1f2021;
  margin-bottom: 40px;

  @media (max-width: 1550px) {
    font-size: 28px;
  }
  @media (max-width: 1330px) {
    font-size: 25px;
  }
  @media (max-width: 1015px) {
    font-size: 32px;
  }
  @media (max-width: 575px) {
    font-size: 24px;
    line-height: 1.75;
  }
`;

const RecognitionP = styled.div`
  font-size: 18px;
  line-height: 2;
  color: #777984;

  @media (max-width: 1550px) {
    font-size: 17px;
  }
  @media (max-width: 1015px) {
    font-size: 18px;
  }
`;

const LeaderShip = styled.div`
  margin-top: 112px;

  @media (max-width: 1015px) {
    text-align: center;
    margin-bottom: 30px;
    margin-top: 80px;
  }
`;

const LeaderShipP = styled.div`
  font-size: 18px;
  line-height: 2;
  color: #777984;
  max-width: 920px;
`;

const LeaderShipHeader = styled.div`
  font-size: 46px;
  line-height: 1.5;
  color: #1f2021;
  margin-top: 30px;
  margin-bottom: 20px;

  @media (max-width: 1015px) {
    font-size: 36px;
    line-height: 1.67;
  }
`;

const BlueLine = styled.div`
  width: 36px;
  height: 3px;
  border-radius: 1.5px;
  background-color: #1fb0e6;
  margin: ${props => props.margin};

  @media (max-width: 1015px) {
    margin: 0 auto;
  }
`;

const HistorySection = styled.div`
  position: relative;
  height: 410px;
  overflow: hidden;

  @media (max-width: 575px) {
    overflow: auto;
    overflow-x: scroll;
    overflow-y: hidden;
    &::-webkit-scrollbar {
      width: 0px;
    }
  }
`;

const SliderContainer = styled.div`
  grid-template-rows: 1fr;
  display: grid;
  height: 410px;
  padding-top: 50px;
  position: absolute;
  left: ${props => `${props.sliderPosition}px`};
  margin-left: ${props => (props.sliderPosition === 0 ? "15%" : "0")};

  @media (max-width: 1700px) {
    margin-left: ${props => (props.sliderPosition === 0 ? "12.5%" : "0")};
  }
  @media (max-width: 1600px) {
    margin-left: ${props => (props.sliderPosition === 0 ? "10%" : "0")};
  }
  @media (max-width: 1250px) {
    margin-left: ${props => (props.sliderPosition === 0 ? "7.5%" : "0")};
  }
  @media (max-width: 1150px) {
    margin-left: ${props => (props.sliderPosition === 0 ? "2.5%" : "0")};
  }
  @media (max-width: 924px) {
    margin-left: ${props => (props.sliderPosition === 0 ? "7.5%" : "0")};
  }
  @media (max-width: 728px) {
    margin-left: ${props => (props.sliderPosition === 0 ? "5%" : "0")};
  }
  @media (max-width: 575px) {
    padding-right: 50px;
  }
`;

const SliderObject = styled.div`
  grid-row: 1/2;
  border-top: ${props => (props.borderTrue ? "solid 2px #ecf8fd" : "")};
  position: relative;
  padding-top: 59px;
  width: 430px;

  @media (max-width: 900px) {
    width: 400px;
  }
  @media (max-width: 400px) {
    width: 330px;
  }
`;

const HistoryTextContainer = styled.div`
  width: 337px;

  @media (max-width: 400px) {
    width: 259px;
  }
`;

const HistoryText = styled.div`
  font-size: 14px;
  line-height: 2;
  color: #777984;
`;

const HistoryYear = styled.div`
  font-size: 24px;
  font-weight: bold;
  line-height: 1.5;
  color: #1f2021;
  margin-bottom: 20px;
`;

const HistoryImageContainer = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 0px 0px 0px 25px;
  background-color: #ecf8fd;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: -32px;
`;

const SliderButton = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 30px;
  box-shadow: 0 10px 15px 0 rgba(66, 79, 86, 0.2);
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

const SliderButtonRight = styled(SliderButton)`
  position: absolute;
  right: 18px;
  top: 41%;

  @media (max-width: 900px) {
    top: 5%;
  }
  @media (max-width: 575px) {
    display: none;
  }
`;

const BottomSliderButtonRight = styled(SliderButtonRight)`
  @media (max-width: 900px) {
    display: none;
  }
`;

const SliderButtonLeft = styled(SliderButton)`
  position: absolute;
  left: 18px;
  top: 41%;

  @media (max-width: 900px) {
    top: 5%;
  }
  @media (max-width: 575px) {
    display: none;
  }
`;

const BottomSliderButtonLeft = styled(SliderButtonLeft)`
  @media (max-width: 900px) {
    display: none;
  }
`;

const TabletHeaderGrid = styled.div`
  @media (min-width: 901px) {
    display: none;
  }

  display: grid;
  grid-template-columns: 1fr 370px 1fr;
  margin-top: 30px;

  @media (max-width: 575px) {
    display: block;
  }
`;

const RightTabletSlider = styled.div`
  justify-self: end;

  @media (max-width: 575px) {
    display: none;
  }
`;

const LeftTabletSlider = styled.div`
  @media (max-width: 575px) {
    display: none;
  }
`;

const OurCulture = styled.div`
  border-radius: 0px 0px 460px 0px;
  background-color: #777984;
  position: relative;
  padding-top: 194px;
  color: #ffffff;
  padding-bottom: 180px;
  margin-top: 50px;

  @media (max-width: 1100px) {
    border-radius: 0px 0px 380px 0px;
  }
  @media (max-width: 1015px) {
    padding-top: 88px;
    border-radius: 0px 0px 0px 250px;
    padding-bottom: 130px;
    background-color: #ffffff;
    background-image: radial-gradient(
        circle at 0 0,
        rgba(255, 255, 255, 0.2),
        rgba(255, 255, 255, 0) 76%
      ),
      linear-gradient(to bottom, #777984, #777984);
  }
  @media (max-width: 575px) {
    border-radius: 0px 0px 100px 0px;
  }
`;

const OurCultureAbsoluteImage = styled.img`
  position: absolute;
  right: 0;
  top: 0;

  @media (max-width: 1700px) {
    max-width: 220px;
  }
  @media (max-width: 1015px) {
    display: none;
  }
`;

const CultureGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;

  @media (max-width: 1015px) {
    display: block;
    text-align: center;
  }
`;

const CultureMainHeader = styled.div`
  font-size: 46px;
  line-height: 1.5;
  max-width: 545px;

  @media (max-width: 1450px) {
    font-size: 42px;
    max-width: 495px;
  }
  @media (max-width: 1300px) {
    font-size: 40px;
    max-width: 471px;
  }
  @media (max-width: 1015px) {
    max-width: 728px;
    margin: 0 auto;
    margin-bottom: 35px;
    font-size: 36px;
    line-height: 1.67;
  }
`;

const CultureTopP = styled.div`
  font-size: 18px;
  line-height: 2;

  @media (max-width: 1450px) {
    font-size: 17px;
  }
  @media (max-width: 1300px) {
    font-size: 16px;
  }
  @media (max-width: 1015px) {
    max-width: 728px;
    margin: 0 auto;
    font-size: 18px;
  }
`;

const CultureMainImage = styled.img`
  width: 100%;

  @media (max-width: 1015px) {
    width: 130%;
    position: absolute;
    top: -60px;
    left: 13px;
  }
  @media (max-width: 767px) {
    width: 156%;
    left: -94px;
  }
  @media (max-width: 630px) {
    width: 189%;
    left: -138px;
  }
  @media (max-width: 450px) {
    width: 222%;
    top: -45px;
    left: -175px;
  }
`;

const CultureMainImageContainer = styled.div`
  height: 560px;
  overflow: hidden;
  border-radius: 0px 0px 230px 0px;
  margin-top: 80px;

  @media (max-width: 1200px) {
    height: 461px;
  }
  @media (max-width: 1015px) {
    display: none;
  }
`;

const CultureTabletImages = styled.div`
  @media (min-width: 1016px) {
    display: none;
  }

  display: grid;
  grid-template-columns: 1fr 2fr;
  grid-gap: 20px;
  margin-top: 55px;

  @media (max-width: 575px) {
    display: block;
  }
`;

const CultureTabletLeftImageContainer = styled.div`
  position: relative;
  overflow: hidden;
  height: 242px;
  max-height: 242px;
  border-radius: 0px 0px 0px 120px;

  @media (max-width: 575px) {
    border-radius: 120px 0px 0px 0px;
    height: 315px;
    max-height: 315px;
    margin-bottom: 25px;
  }
`;

const CultureTabletRightImageContainer = styled.div`
  position: relative;
  height: 242px;
  max-height: 242px;
  overflow: hidden;
  border-radius: 0px 0px 120px 0px;

  @media (max-width: 575px) {
    height: 315px;
    max-height: 315px;
  }
`;

const CultureTabletLeftImage = styled.img`
  width: 126%;
  position: absolute;
  top: -17px;
  left: -22px;

  @media (max-width: 850px) {
    width: 145%;
    top: 5px;
    left: -25px;
  }
  @media (max-width: 630px) {
    width: 172%;
    top: 0px;
    left: -45px;
  }
  @media (max-width: 575px) {
    width: 110%;
    top: 0px;
    left: -47px;
  }
  @media (max-width: 450px) {
    width: 134%;
    left: -47px;
  }
`;

const CultureMainContentGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin-top: 35px;
  padding-bottom: 85px;

  @media (max-width: 1015px) {
    display: block;
    padding-bottom: 20px;
  }
`;

const CultureMainContentGridRight = styled.div`
  padding-top: 90px;

  @media (max-width: 1015px) {
    padding-top: 70px;
    margin: auto;
    max-width: 585px;
  }
`;

const CultureMainContentImage = styled.img`
  max-width: 85%;

  @media (max-width: 1015px) {
    display: none;
  }
`;

const CultureMainContentGridInnerGrid = styled.div`
  display: grid;
  grid-template-columns: 96px 1fr;
  grid-gap: 47px;
  margin-bottom: 84px;

  @media (max-width: 575px) {
    display: block;
    text-align: center;
    margin-bottom: 77px;
  }
`;

const CultureMainContentGridInnerGridLeft = styled.div`
  width: 96px;
  height: 96px;
  box-shadow: 29px 29px 44px 0 rgba(31, 32, 33, 0.2);
  background-color: #777984;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 575px) {
    margin: 0 auto;
    margin-bottom: 34px;
  }
`;

const CultureMainContentGridInnerGridRight = styled.div`
  font-size: 18px;
  line-height: 2;
  max-width: 438px;

  @media (max-width: 1300px) {
    font-size: 17px;
  }
  @media (max-width: 1015px) {
    font-size: 18px;
  }
  @media (max-width: 575px) {
    max-width: 100%;
  }
`;

const CultureFooter = styled.div`
  border-top: solid 1px rgba(255, 255, 255, 0.1);
  padding-top: 75px;

  @media (max-width: 767px) {
    width: 85%;
    margin: 0 auto;
  }
`;

const CultureFooterText = styled.div`
  margin: 0 auto;
  font-size: 40px;
  line-height: 1.5;
  text-align: center;
  max-width: 920px;

  @media (max-width: 1300px) {
    font-size: 37px;
  }
  @media (max-width: 1100px) {
    font-size: 35px;
    max-width: 757px;
  }
  @media (max-width: 1015px) {
    font-size: 36px;
    line-height: 1.67;
  }
  @media (max-width: 575px) {
    font-size: 24px;
    line-height: 1.75;
  }
`;

const Partnership = styled.div`
  position: relative;
  padding-top: 200px;

  @media (max-width: 1015px) {
    padding-top: 120px;
  }
`;

const PartnershipAbsoluteImage = styled.img`
  position: absolute;
  top: -1px;
  left: 0;

  @media (max-width: 1500px) {
    max-width: 200px;
  }
  @media (max-width: 1015px) {
    display: none;
  }
`;

const PartnershipHeader = styled.div`
  font-size: 46px;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: center;
  color: #1f2021;
  max-width: 940px;
  margin: 0 auto;
  margin-top: 30px;

  @media (max-width: 1100px) {
    max-width: 775px;
    font-size: 38px;
  }
  @media (max-width: 1015px) {
    max-width: 600px;
    font-size: 36px;
  }
`;

const PartnersGrid = styled.div`
  display: grid;
  grid-gap: 92px;
  grid-template-columns: auto auto auto auto auto auto;
  margin: 0 auto;
  margin-top: 65px;
  width: 86%;

  @media (max-width: 1100px) {
    margin-top: 55px;
  }
  @media (max-width: 1015px) {
    grid-template-columns: auto auto auto;
    max-width: 603px;
    grid-row-gap: 48px;
    grid-column-gap: 100px;
  }
  @media (max-width: 500px) {
    grid-template-columns: auto auto;
    max-width: 309px;
  }
  @media (max-width: 400px) {
    grid-template-columns: auto auto;
    max-width: 100%;
    width: 100%;
    grid-column-gap: 0px;
  }
`;

const PartnerImageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const PartnerImage = styled.img`
  max-height: 71px;
  max-width: 100%;

  @media (max-width: 500px) {
    max-width: 100px;
  }
`;

const PartnersBottomGrid = styled.div`
  display: grid;
  grid-template-columns: 1.2fr 1fr;
  margin-top: 90px;
  grid-gap: 77px;

  @media (max-width: 1825px) {
    grid-template-columns: 1.3fr 1fr;
    grid-gap: 70px;
  }
  @media (max-width: 1425px) {
    grid-gap: 45px;
  }
  @media (max-width: 1015px) {
    display: block;
    text-align: center;
    max-width: 650px;
    margin: 0 auto;
    margin-top: 80px;
  }
`;

const PartnersBottomHeader = styled.div`
  font-size: 38px;
  line-height: 1.5;
  color: #1f2021;

  @media (max-width: 1825px) {
    font-size: 37px;
  }
  @media (max-width: 1500px) {
    font-size: 35px;
  }
  @media (max-width: 1425px) {
    font-size: 34px;
  }
  @media (max-width: 1015px) {
    font-size: 36px;
    margin-bottom: 40px;
    line-height: 1.67;
  }
  @media (max-width: 575px) {
    font-size: 24px;
    margin-bottom: 35px;
    line-height: 1.75;
  }
`;

const PartnersBottomP = styled.div`
  font-size: 18px;
  line-height: 2;
  color: #777984;
  margin-bottom: 30px;

  @media (max-width: 1825px) {
    font-size: 17px;
  }
  @media (max-width: 1500px) {
    font-size: 16px;
  }
  @media (max-width: 1015px) {
    font-size: 18px;
  }
`;

const NewsSection = styled.div`
  text-align: center;
  margin-top: 150px;

  @media (max-width: 575px) {
    margin-top: 86px;
  }
`;

const NewsHeader = styled.div`
  font-size: 46px;
  line-height: 1.5;
  color: #1f2021;
  margin-top: 30px;

  @media (max-width: 1015px) {
    line-height: 1.67;
    font-size: 36px;
  }
  @media (max-width: 900px) {
    display: none;
  }
`;

const TabletNewsHeader = styled(NewsHeader)`
  @media (max-width: 900px) {
    display: block;
    margin-top: 0;
  }
`;

const NewsMainGrid = styled.div`
  display: grid;
  grid-template-rows: 150px 302px 1fr;
  grid-template-columns: 1fr;
  position: relative;
  overflow: hidden;
  margin-top: 57px;

  @media (max-width: 1600px) {
    grid-template-rows: 120px 322px 1fr;
  }
  @media (max-width: 575px) {
    grid-template-rows: 243px 309px 1fr;
  }
`;

const NewsOrangeBg = styled.div`
  grid-row: 2/4;
  grid-column: 1/2;
  background-color: rgba(251, 212, 152, 0.1);
  border-radius: 460px 0px 0px 0px;
  padding-top: 463px;
  position: relative;
  padding-bottom: 175px;

  @media (max-width: 1600px) {
    border-radius: 400px 0px 0px 0px;
    padding-top: 483px;
  }
  @media (max-width: 1100px) {
    padding-bottom: 0px;
  }
  @media (max-width: 575px) {
    border-radius: 0px 0px 100px 0px;
    padding-top: 351px;
  }
`;

const GivingSection = styled.div`
  display: grid;
  grid-template-columns: 1.5fr 1fr;
  text-align: left;
  grid-gap: 25px;

  @media (max-width: 1850px) {
    grid-template-columns: 1.6fr 1fr;
  }
  @media (max-width: 1800px) {
    grid-template-columns: 1.8fr 1fr;
  }
  @media (max-width: 1100px) {
    display: block;
    width: 80%;
    text-align: center;
  }
  @media (max-width: 724px) {
    width: 90%;
  }
`;

const GivingSectionAbsoluteImage = styled.img`
  grid-row: 3/4;
  grid-column: 1/2;
  position: absolute;
  bottom: 0;
  right: 0;
  height: 100%;
  width: auto;

  @media (max-width: 1300px) {
    display: none;
  }
`;

const GivingSectionLeft = styled.div`
  padding-top: 87px;

  @media (max-width: 1800px) {
    padding-top: 61px;
  }
  @media (max-width: 1100px) {
    padding-top: 0px;
  }
`;

const GivingSectionImage = styled.img`
  width: 100%;

  @media (max-width: 1100px) {
    max-width: 508px;
    margin-top: 40px;
  }
`;

const GivingSectionHeader = styled.div`
  font-size: 38px;
  line-height: 1.5;
  color: #1f2021;
  margin-bottom: 50px;

  @media (max-width: 1400px) {
    font-size: 35px;
    line-height: 1.4;
    margin-bottom: 50px;
  }
  @media (max-width: 1100px) {
    margin-bottom: 40px;
  }
  @media (max-width: 1015px) {
    line-height: 1.67;
    font-size: 36px;
  }
  @media (max-width: 575px) {
    line-height: 1.75;
    font-size: 24px;
  }
`;

const GivingSectionPGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 25px;

  @media (max-width: 1100px) {
    display: block;
  }
`;

const GivingSectionP = styled.div`
  font-size: 17px;
  line-height: 2;
  color: #777984;

  @media (max-width: 1400px) {
    font-size: 16px;
    line-height: 1.8;
  }
  @media (max-width: 1100px) {
    margin-bottom: 23px;
  }
  @media (max-width: 1015px) {
    font-size: 18px;
    line-height: 2;
  }
`;

const NewsRowGridContaner = styled.div`
  position: relative;
  grid-row: 1/3;
  grid-column: 1/2;
  z-index: 1;

  @media (max-width: 575px) {
    overflow: auto;
    overflow-x: scroll;
    overflow-y: hidden;

    &::-webkit-scrollbar {
      width: 0px;
    }
  }
`;

const NewsRowGrid = styled.div`
  display: grid;
  grid-template-rows: 1fr;
  align-self: flex-start;
  grid-gap: 38px;
  position: absolute;
  left: ${props => `${props.sliderPosition}px`};
  margin-left: ${props => (props.sliderPosition === 0 ? "15%" : "0")};

  @media (max-width: 1700px) {
    margin-left: ${props => (props.sliderPosition === 0 ? "12.5%" : "0")};
  }
  @media (max-width: 1600px) {
    margin-left: ${props => (props.sliderPosition === 0 ? "10%" : "0")};
  }
  @media (max-width: 1250px) {
    margin-left: ${props => (props.sliderPosition === 0 ? "7.5%" : "0")};
  }
  @media (max-width: 1150px) {
    margin-left: ${props => (props.sliderPosition === 0 ? "2.5%" : "0")};
  }
  @media (max-width: 924px) {
    margin-left: ${props => (props.sliderPosition === 0 ? "7.5%" : "0")};
  }
  @media (max-width: 728px) {
    margin-left: ${props => (props.sliderPosition === 0 ? "5%" : "0")};
  }
  @media (max-width: 575px) {
    padding-right: 50px;
  }
`;

const NewsItem = styled(ClearedStyleHref)`
  grid-row: 1/2;
  width: 375px;
  height: 452px;
  border-radius: 0px 0px 0px 50px;
  box-shadow: 0 30px 50px 0 rgba(66, 79, 86, 0.07);
  background-color: #ffffff;
  padding-right: 30px;
  padding-left: 40px;
  text-align: left;
  display: grid;
  grid-template-rows: 90px 1fr 50px;

  @media (max-width: 1600px) {
    width: 354px;
    height: 446px;
  }
  @media (max-width: 575px) {
    width: 302px;
    height: 467px;
  }
`;

const NewsItemHeader = styled.div`
  font-size: 24px;
  font-weight: bold;
  line-height: 1.5;
  color: #1f2021;
  margin-top: 60px;
`;

const NewsItemImage = styled.img`
  max-width: 103px;
  align-self: end;
`;

const NewsLinkContainer = styled.div`
  color: #ff9c1b;
  text-align: right;
`;

const NewsItemLink = styled.span`
  justify-self: end;
  font-size: 16px;
  line-height: 1.88;
  color: #ff9c1b;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

const MascotSection = styled.div`
  position: relative;
  padding-bottom: 160px;

  @media (max-width: 1015px) {
    padding-bottom: 105px;
  }
`;

const MascotContent = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  padding-top: 208px;
  grid-gap: 122px;

  @media (max-width: 1400px) {
    grid-gap: 50px;
  }
  @media (max-width: 1015px) {
    display: block;
    text-align: center;
    padding-top: 105px;
  }
`;

const MascotAbsoluteImage = styled.img`
  position: absolute;
  top: -1px;
  left: 0;
  max-width: 208px;

  @media (max-width: 1700px) {
    max-width: 165px;
  }
  @media (max-width: 1400px) {
    max-width: 138px;
  }
  @media (max-width: 1015px) {
    display: none;
  }
`;

const MascotHeader = styled.div`
  font-size: 46px;
  line-height: 1.5;
  color: #1f2021;
  margin-top: 30px;
  margin-bottom: 45px;

  @media (max-width: 1450px) {
    font-size: 44px;
    margin-bottom: 38px;
  }
  @media (max-width: 1200px) {
    font-size: 41px;
    margin-bottom: 32px;
  }
  @media (max-width: 1015px) {
    font-size: 36px;
    line-height: 1.67;
  }
`;

const MascotSecondHeader = styled.div`
  font-size: 38px;
  line-height: 1.5;
  color: #1f2021;
  margin-bottom: 55px;

  @media (max-width: 1450px) {
    font-size: 35px;
    margin-bottom: 45px;
  }
  @media (max-width: 1200px) {
    font-size: 33px;
    margin-bottom: 28px;
  }
  @media (max-width: 1015px) {
    font-size: 24px;
  }
`;

const MascotP = styled.div`
  font-size: 18px;
  line-height: 2;
  color: #777984;

  @media (max-width: 1450px) {
    font-size: 17px;
  }
  @media (max-width: 1200px) {
    line-height: 1.8;
  }
  @media (max-width: 1015px) {
    font-size: 18px;
    line-height: 2;
  }
`;

const MascotImage = styled.img`
  width: 100%;
  border-radius: 0px 0px 230px 0px;
  @media (max-width: 1015px) {
    border-radius: 0px 0px 200px 0px;
    max-width: 500px;
    margin-top: 65px;
  }
  @media (max-width: 575px) {
    border-radius: 0px 0px 100px 0px;
  }
`;

const historyArray = [
  {
    image: "https://cdn.cardcash.com/website/ui/about/profile.svg",
    year: 2009,
    text: "CardCash was co-founded in 2009 by two childhood friends, Chief Executive Officer Elliot Bohm and Chief Operating Officer Marc Ackerman. The pair started the web’s first secondary gift card market for unused gift cards."
  },
  {
    image: "https://cdn.cardcash.com/website/ui/about/cash4.svg",
    year: 2013,
    text: "CardCash.com raised $6 million in Series A funding from Guggenheim Partners, a well known global financial service company with more than $200 billion in assets under management."
  },
  {
    image: "https://cdn.cardcash.com/website/ui/about/cash4.svg",
    year: 2014,
    text: "CardCash raises $6 million in debt funding from Sterling National Bank, a subsidiary of Sterling Bancorp."
  },
  {
    image: "https://cdn.cardcash.com/website/ui/about/merge.svg",
    year: 2014,
    text: "CardCash acquires Silicon Valley-based competitor Plastic Jungle and that same year, formed a strategic partnership with Incomm Corporation, a leader in prepaid and payment solutions."
  },
  {
    image: "https://cdn.cardcash.com/website/ui/about/profile.svg",
    year: 2014,
    text: "Executive Vice President of Sales and Business Development, Thomas Ochoa, who has experience leading teams at digital payment companies, InComm Corporation and the BlackHawk Network joins the effort."
  },
  {
    image: "https://cdn.cardcash.com/website/ui/about/profile.svg",
    year: 2016,
    text: "CardCash hires Chief Technology Officer Thomas Butt, who managed software engineering teams at General Electric, Lockheed Martin, and multiple startups. In his short time, Butt's team restructured CardCash's entire ecommerce platform with highly scalable microservices that connect to single page applications."
  },
  {
    image: "https://cdn.cardcash.com/website/ui/about/star.svg",
    year: 2017,
    text: "CardCash's continued ecommerce success earned recognition in Inc 5000's Nation’s Fastest-Growing Companies list for the sixth straight year, among a mere four-percent of all the companies that qualified. CardCash was also named one of Forbes' Most Promising Companies and has been featured in publications such as CNN, Bloomberg and the New York Times."
  },
  {
    image: "https://cdn.cardcash.com/website/ui/about/star.svg",
    year: 2017,
    text: "CardCash partnered with Charity On Top to provide an innovative form of fundraising for victims of Hurricane Harvey. The proceeds went to the American Red Cross, Greater Houston Community Foundation's Hurricane Harvey Relief Fund, the Houston Food Bank and Houston Humane Society and Americares."
  },
  {
    image: "https://cdn.cardcash.com/website/ui/about/merge.svg",
    year: 2018,
    text: "CardCash partnered with St. Jude’s Research Hospital and together are on a mission to advance cures, and means of prevention, for pediatric catastrophic diseases through research and treatment."
  },
  {
    image: "https://cdn.cardcash.com/website/ui/about/merge.svg",
    year: 2019,
    text: "CardCash partners with Starbucks to launch the Starbucks Gift Card Exchange program, Starbucks customers can trade in any brand's gift card for a new Starbucks gift card."
  },
  {
    image: "https://cdn.cardcash.com/website/ui/about/launch.svg",
    year: 2019,
    text: "CardCash launches FraudFix, a fraud solution built on AI, tailored to the unique needs of selling digital goods online."
  },
  {
    image: "https://cdn.cardcash.com/website/ui/about/launch.svg",
    year: 2020,
    text: "CardCash Giving is launched, a brand new mobile app connecting shoppers to causes they support."
  },
  {
    image: "https://cdn.cardcash.com/website/ui/about/merge.svg",
    year: 2023,
    text: "RDE Inc. (Restaurant.com) acquires CardCash.com, marking a significant milestone in CardCash's expansion."
  },
  {
    image: "https://cdn.cardcash.com/website/ui/about/launch.svg",
    year: 2024,
    text: "RDE, Inc., the parent company of CardCash.com, begins trading on the Nasdaq under the ticker symbol 'RSTN', joining some of the world's most innovative companies."
  }
];

const partnershipBrands = [
  "https://cdn.cardcash.com/website/ui/about/walmart_logo.png",
  "https://cdn.cardcash.com/website/ui/about/uber_logo.png",
  "https://cdn.cardcash.com/website/ui/about/amazon_logo.png",
  "https://cdn.cardcash.com/website/ui/about/starbucks_logo.png",
  "https://cdn.cardcash.com/website/ui/about/cvs_logo.png",
  "https://cdn.cardcash.com/website/ui/about/bbb_logo.svg"
];

const NewsArray = [
  {
    name: "WIRED",
    image: "https://cdn.cardcash.com/website/ui/about/Wired_logo.png",
    title:
      "CardCash offers up discounts on gift cards, which are otherwise difficult to find",
    link: "https://www.wired.com/gallery/extremely-last-minute-gift-ideas/"
  },
  {
    name: "CNET",
    image: "https://cdn.cardcash.com/website/ui/about/Cnet_logo.png",
    title:
      "Selling through CardCash is your best and most convenient option for selling a gift card online",
    link: "https://www.cnet.com/personal-finance/how-to-buy-and-sell-gift-cards-legitimately/"
  },
  {
    name: "WSJ",
    image: "https://cdn.cardcash.com/website/ui/about/wsj_logo.svg",
    title: "Guggenheim Partners Provides Growth Funding to CardCash.com",
    link: "https://www.wsj.com/articles/DJFLBO0020131108e9b8j8jun"
  },
  {
    name: "Forbes",
    image: "https://cdn.cardcash.com/website/ui/about/forbes_logo.png",
    title:
      "CardCash Inks Wal-Mart Deal To Grab A Bigger Chunk Of The Used Gift Card Market",
    link: "https://www.forbes.com/sites/karstenstrauss/2015/01/27/cardcash-inks-wal-mart-deal-to-grab-a-bigger-chunk-of-the-used-gift-card-market/#3a9d9e7e7d2a"
  },
  {
    name: "Inc.",
    image: "https://cdn.cardcash.com/website/ui/about/inc_logo.png",
    title: "CardCash: The Cure for Unwanted Gift Cards",
    link: "https://www.inc.com/john-mcdermott/applicant-of-the-week-cardcash.html"
  },
  {
    name: "Fintech",
    image: "https://cdn.cardcash.com/website/ui/about/fintech-logo.png",
    title: "CardCash.com Acquires Plastic Jungle",
    link: "https://www.fintechfutures.com/2014/07/cardcash-com-acquires-plastic-jungle-july-31-2014/"
  },
  {
    name: "NJBIZ",
    image: "https://cdn.cardcash.com/website/ui/about/njbiz.png",
    title:
      "CardCash lands at No. 17 on the NJBIZ list of the 50 fastest growing companies in New Jersey",
    link: "https://njbiz.com/cardcash-co-founders-created-secondary-market-for-unwanted-gift-cards-2/"
  },
  {
    name: "Money.com",
    image: "https://cdn.cardcash.com/website/ui/about/money_logo.svg",
    title: "CardCash.com was best gift card exchange site for sellers",
    link: "https://money.com/sell-gift-cards-for-cash/"
  },
  {
    name: "ABC13",
    image: "https://cdn.cardcash.com/website/ui/about/abc13_logo.png",
    title: "If you're selling a gift card, try CardCash.com",
    link: "https://abc13.com/gift-card-how-to-sell-a-selling-an-unwanted-get-cash-for-cards/4968412/"
  },
  {
    name: "Fox13",
    image: "https://cdn.cardcash.com/website/ui/about/fox_logo.png",
    title:
      "Yes, the CardCash.com offer of $418.90 beats the CardPool offer by more than $20!",
    link: "https://www.fox13memphis.com/news/consumer/clark-howard/how-make-most-money/Y7DHSERNWSDUWZZCHOTGFCLOKY/"
  },
  {
    name: "APP",
    image: "https://cdn.cardcash.com/website/ui/about/app_logo.svg",
    title: "2,223 gift cards, one giant American flag",
    link: "https://www.app.com/videos/news/2018/05/25/2223-gift-cards-one-giant-american-flag/35360667/"
  }
];

historyArray.reverse(); // we want to show the latest news first

const AboutUs = () => {
  const dispatch = useDispatch();
  const [sliderPosition, changeSliderPosition] = useState(0);
  const [slidingAmount, changeSlidingAmount] = useState(430);
  const [slidingAmountClicks, changeSlidingAmountClicks] = useState(0);
  const [amountOfSlides, changeAmountOfSlides] = useState(
    historyArray.length - 4
  );
  const [newsSliderPosition, changeNewsSliderPosition] = useState(0);
  const [newsSlidingAmount, changeNewsSlidingAmount] = useState(375);
  const [amountOfNewsSlides, changeAmountOfNewsSlides] = useState(
    NewsArray.length - 3
  );
  const [newSlidingAmountClicks, changeNewSlidingAmountClicks] = useState(0);

  useEffect(() => {
    dispatch(initAppBrowser(["messages"]));
    if (window && window.innerWidth) {
      if (window.innerWidth > 1500) {
        changeSlidingAmount(430);
        changeNewsSlidingAmount(375);
      } else if (window.innerWidth > 1200) {
        changeSlidingAmount(480);
        changeNewsSlidingAmount(425);
      } else if (window.innerWidth < 900) {
        changeSlidingAmount(400);
        changeAmountOfSlides(historyArray.length - 2);
        changeAmountOfNewsSlides(NewsArray.length - 2);
      } else {
        changeSlidingAmount(500);
        changeNewsSlidingAmount(460);
      }
    }
  }, []);
  return (
    <div className="mar-t-125 about-main">
      <Helmet title="About Us | CardCash" />
      <div>
        <div>
          <InnerHeader>
            <HeaderTextContainer className={"main-container-page-width"}>
              <HeaderText>We are CardCash. Discover our story.</HeaderText>
              <HeaderP>
                CardCash is taking the world in an imaginative new direction,
                saving customers money.
              </HeaderP>
            </HeaderTextContainer>
            <AbsoluteImages>
              <LeftImage
                src="https://cdn.cardcash.com/website/ui/about/hero-left3.svg"
                alt=""
              />
              <RightImage
                src="https://cdn.cardcash.com/website/ui/about/hero-right.png"
                alt=""
              />
              <TabletImage
                src="https://cdn.cardcash.com/website/ui/about/hero-left.svg"
                alt=""
              />
            </AbsoluteImages>
            <LeftSide></LeftSide>
            <RightSide>
              <ImageContainer>
                <Image
                  src="https://cdn.cardcash.com/website/ui/about/hero.jpg"
                  alt=""
                />
                <TabletMainImage
                  src="https://cdn.cardcash.com/website/ui/about/hero-tablet.jpg"
                  alt=""
                />
              </ImageContainer>
            </RightSide>
          </InnerHeader>
        </div>
        <OpeningStatement>
          <CurvedImageContainer>
            <CurvedImage
              src="https://cdn.cardcash.com/website/ui/about/cash4.svg"
              alt=""
            />
          </CurvedImageContainer>
          <OpeningStatementP>
            CardCash has the world's largest inventory of discounted gift cards
            and since its inception, has saved customers more than $50 million
            from their favorite retail brands.
          </OpeningStatementP>
          <OpeningStatementP>
            Today, we continue our tradition of keeping an open dialog with
            consumers, constantly evolving new, innovative ways to get the best
            price. We have a strong mission of never letting anyone pay the full
            amount for anything by turning the world's over $140 billion of
            unused gift cards into major discounts.
          </OpeningStatementP>
        </OpeningStatement>
        <Recognition className={"main-container-page-width"}>
          <RecognitionLeft>
            <RecognitionHeader>
              CardCash's continued ecommerce success earned recognition in Inc
              5000's Nation’s Fastest-Growing Companies list for the sixth
              straight year in 2017, among a mere four-percent of all the
              companies that qualified.
            </RecognitionHeader>
            <RecognitionP>
              CardCash was also named one of Forbes' Most Promising Companies
              and has been featured in publications such as CNN, Bloomberg and
              the New York Times.
            </RecognitionP>
          </RecognitionLeft>
          <RecognitionRight>
            <RecognitionImage
              src="https://cdn.cardcash.com/website/ui/about/awards.png"
              alt=""
            />
          </RecognitionRight>
        </Recognition>
        <LeaderShip className={"main-container-page-width"}>
          <BlueLine />
          <LeaderShipHeader>A brief history of CardCash</LeaderShipHeader>
          <LeaderShipP>
            Since CardCash started selling gift cards in 2008, we've been
            dedicated to making a difference in the lives of our customers. Our
            business is the result of visionary leadership, with decades of
            experience across diverse industries, dedicated to helping customers
            save money and live better.
          </LeaderShipP>
        </LeaderShip>
        <HistorySection>
          <SliderContainer
            sliderPosition={sliderPosition}
            className={"transition-left"}
          >
            {historyArray.map((item, index) => (
              <SliderObject
                key={index}
                borderTrue={index < historyArray.length - 1}
              >
                <HistoryImageContainer>
                  <CurvedImage src={item.image} alt="" />
                </HistoryImageContainer>
                <HistoryTextContainer>
                  <HistoryYear>{item.year} </HistoryYear>
                  <HistoryText>{item.text} </HistoryText>
                </HistoryTextContainer>
              </SliderObject>
            ))}
          </SliderContainer>
          {sliderPosition > -slidingAmount * amountOfSlides && (
            <SliderButtonRight
              onClick={() => {
                changeSliderPosition(
                  slidingAmountClicks > 0
                    ? sliderPosition - slidingAmount
                    : sliderPosition - slidingAmount / 2
                );
                changeSlidingAmountClicks(slidingAmountClicks + 1);
              }}
            >
              <FaArrowRight style={{ color: "#ff9c1b" }} />
            </SliderButtonRight>
          )}
          {sliderPosition < 0 && (
            <SliderButtonLeft
              onClick={() => {
                changeSliderPosition(
                  slidingAmountClicks === 1
                    ? sliderPosition + slidingAmount / 2
                    : sliderPosition + slidingAmount
                );
                changeSlidingAmountClicks(slidingAmountClicks - 1);
              }}
            >
              <FaArrowLeft style={{ color: "#ff9c1b" }} />
            </SliderButtonLeft>
          )}
        </HistorySection>

        <OurCulture>
          <OurCultureAbsoluteImage
            src="https://cdn.cardcash.com/website/ui/about/white-elements.svg"
            alt=""
          />
          <div className={"main-container-page-width"}>
            <CultureGrid>
              <CultureMainHeader>
                Look through a wider lens at CardCash to learn about our
                culture.
              </CultureMainHeader>
              <CultureTopP>
                We hire team members of diverse backgrounds and experiences that
                love coming to a place, where everyone feels they belong. We
                know diversity and inclusion are values critical to our success
                and future innovation. We believe employees work best when
                comfortable and offer a casual work environment where we can
                also have fun.
              </CultureTopP>
            </CultureGrid>
            <CultureTabletImages>
              <CultureTabletLeftImageContainer>
                <CultureTabletLeftImage
                  src="https://cdn.cardcash.com/website/ui/about/work.png"
                  alt=""
                />
              </CultureTabletLeftImageContainer>
              <CultureTabletRightImageContainer>
                <CultureMainImage
                  src="https://cdn.cardcash.com/website/ui/about/bbq.jpg"
                  alt=""
                />
              </CultureTabletRightImageContainer>
            </CultureTabletImages>
            <CultureMainImageContainer>
              <CultureMainImage
                src="https://cdn.cardcash.com/website/ui/about/bbq.jpg"
                alt=""
              />
            </CultureMainImageContainer>
            <CultureMainContentGrid>
              <div>
                <CultureMainContentImage
                  src="https://cdn.cardcash.com/website/ui/about/work.png"
                  alt=""
                />
              </div>
              <CultureMainContentGridRight>
                <CultureMainContentGridInnerGrid>
                  <CultureMainContentGridInnerGridLeft>
                    <img
                      src="https://cdn.cardcash.com/website/ui/about/ping-pong.svg"
                      alt=""
                    />
                  </CultureMainContentGridInnerGridLeft>
                  <CultureMainContentGridInnerGridRight>
                    We also offer collaborative monthly team lunches,
                    hoverboards, and footballs to toss around the office as we
                    get down to business.
                  </CultureMainContentGridInnerGridRight>{" "}
                </CultureMainContentGridInnerGrid>
                <CultureMainContentGridInnerGrid>
                  <CultureMainContentGridInnerGridLeft>
                    <img
                      src="https://cdn.cardcash.com/website/ui/about/hat.svg"
                      alt=""
                    />
                  </CultureMainContentGridInnerGridLeft>
                  <CultureMainContentGridInnerGridRight>
                    In addition, we have a comprehensive benefits package and
                    believe in furthering the education of our employees,
                    allowing them to attend and speak at conferences.
                  </CultureMainContentGridInnerGridRight>
                </CultureMainContentGridInnerGrid>
              </CultureMainContentGridRight>
            </CultureMainContentGrid>
          </div>
          <CultureFooter>
            <CultureFooterText>
              As a lean and talented startup that has a responsible approach to
              business and collaboration, CardCash is the ideal environment of
              responding to customers’ needs without anything getting in our
              way.
            </CultureFooterText>
          </CultureFooter>
        </OurCulture>
        <Partnership>
          <PartnershipAbsoluteImage
            src="https://cdn.cardcash.com/website/ui/about/elements-right.svg"
            alt=""
          />
          <div className={"main-container-page-width"}>
            <BlueLine margin={"0 auto"} />
            <PartnershipHeader>
              CardCash has success from partnerships with major retailers.
            </PartnershipHeader>
            <PartnersGrid>
              {partnershipBrands.map((item, index) => (
                <PartnerImageContainer key={index}>
                  <PartnerImage src={item} alt="partner" />
                </PartnerImageContainer>
              ))}
            </PartnersGrid>
            <PartnersBottomGrid>
              <PartnersBottomHeader>
                We believe our actions today determine who we are in the future.
                We don't charge fees. We just want to earn money together.
              </PartnersBottomHeader>
              <div>
                <PartnersBottomP>
                  CardCash doesn't only want to help consumers save, but also
                  help brands earn a new revenue stream through the world of
                  gift cards, without discounting their products.
                </PartnersBottomP>{" "}
                <PartnersBottomP>
                  Our goal is to create truly useful and beautiful tools that
                  help your business become more successful. We believe the
                  world is changing to a more digital era and want to help both
                  ecommerce platforms and big-box retailers better compete.
                </PartnersBottomP>
              </div>
            </PartnersBottomGrid>
          </div>
        </Partnership>

        <NewsSection>
          <BlueLine margin={"0 auto"} />
          <NewsHeader>Read news about us</NewsHeader>
          <TabletHeaderGrid className={"main-container-page-width"}>
            <LeftTabletSlider>
              {newsSliderPosition < 0 && (
                <SliderButton
                  onClick={() => {
                    changeNewsSliderPosition(
                      newSlidingAmountClicks === 1
                        ? newsSliderPosition + newsSlidingAmount / 2
                        : newsSliderPosition + newsSlidingAmount
                    );
                    changeNewSlidingAmountClicks(newSlidingAmountClicks - 1);
                  }}
                >
                  <FaArrowLeft style={{ color: "#ff9c1b" }} />
                </SliderButton>
              )}
            </LeftTabletSlider>
            <TabletNewsHeader>Read news about us</TabletNewsHeader>
            <RightTabletSlider>
              {newsSliderPosition > -newsSlidingAmount * amountOfNewsSlides && (
                <SliderButton
                  onClick={() => {
                    changeNewsSliderPosition(
                      newSlidingAmountClicks > 0
                        ? newsSliderPosition - newsSlidingAmount
                        : newsSliderPosition - newsSlidingAmount / 2
                    );
                    changeNewSlidingAmountClicks(newSlidingAmountClicks + 1);
                  }}
                >
                  <FaArrowRight style={{ color: "#ff9c1b" }} />
                </SliderButton>
              )}
            </RightTabletSlider>
          </TabletHeaderGrid>
          <NewsMainGrid>
            <NewsRowGridContaner>
              <NewsRowGrid
                className={"transition-left-faster"}
                sliderPosition={newsSliderPosition}
              >
                {NewsArray.map((item, index) => (
                  <NewsItem key={index} href={item.link} target="_blank">
                    <NewsItemImage src={item.image} alt="" />
                    <NewsItemHeader>{item.title}</NewsItemHeader>
                    <NewsLinkContainer>
                      <NewsItemLink>
                        Read more{" "}
                        <IoIosArrowForward style={{ marginLeft: "4px" }} />
                      </NewsItemLink>
                    </NewsLinkContainer>
                  </NewsItem>
                ))}
              </NewsRowGrid>
              {newsSliderPosition > -newsSlidingAmount * amountOfNewsSlides && (
                <BottomSliderButtonRight
                  onClick={() => {
                    changeNewsSliderPosition(
                      newSlidingAmountClicks > 0
                        ? newsSliderPosition - newsSlidingAmount
                        : newsSliderPosition - newsSlidingAmount / 2
                    );
                    changeNewSlidingAmountClicks(newSlidingAmountClicks + 1);
                  }}
                >
                  <FaArrowRight style={{ color: "#ff9c1b" }} />
                </BottomSliderButtonRight>
              )}
              {newsSliderPosition < 0 && (
                <BottomSliderButtonLeft
                  onClick={() => {
                    changeNewsSliderPosition(
                      newSlidingAmountClicks === 1
                        ? newsSliderPosition + newsSlidingAmount / 2
                        : newsSliderPosition + newsSlidingAmount
                    );
                    changeNewSlidingAmountClicks(newSlidingAmountClicks - 1);
                  }}
                >
                  <FaArrowLeft style={{ color: "#ff9c1b" }} />
                </BottomSliderButtonLeft>
              )}
            </NewsRowGridContaner>

            <NewsOrangeBg>
              <GivingSection className={"main-container-page-width"}>
                <GivingSectionLeft>
                  <GivingSectionHeader>
                    At CardCash, we believe everyone deserves the chance to
                    learn, succeed, and be heard, which drives us to help those
                    most in need.
                  </GivingSectionHeader>
                  <GivingSectionPGrid>
                    <GivingSectionP>
                      In 2017, CardCash partnered with Charity On Top to provide
                      an innovative form of fundraising for victims of Hurricane
                      Harvey. The proceeds went to the American Red Cross,
                      Greater Houston Community Foundation's Hurricane Harvey
                      Relief Fund, the Houston Food Bank and Houston Humane
                      Society and Americares.
                    </GivingSectionP>
                    <GivingSectionP>
                      CardCash also partnered with St. Jude’s Research Hospital
                      in 2017 and together are on mission to advance cures, and
                      means of prevention, for pediatric catastrophic diseases
                      through research and treatment.
                    </GivingSectionP>
                  </GivingSectionPGrid>
                </GivingSectionLeft>
                <div>
                  <GivingSectionImage
                    src="https://cdn.cardcash.com/website/ui/about/ccgiving.png"
                    alt="icon"
                  />
                </div>
              </GivingSection>
            </NewsOrangeBg>
            <GivingSectionAbsoluteImage
              src="https://cdn.cardcash.com/website/ui/about/giving_right.svg"
              alt=""
            />
          </NewsMainGrid>
        </NewsSection>

        <MascotSection>
          <MascotAbsoluteImage
            src="https://cdn.cardcash.com/website/ui/about/elements-right.svg"
            alt=""
          />
          <MascotContent className={"main-container-page-width"}>
            <div>
              <BlueLine />
              <MascotHeader>Meet Cookie</MascotHeader>
              <MascotSecondHeader>
                Because behind every great company is a great mascot
              </MascotSecondHeader>
              <MascotP>
                Here at CardCash, we have Cookie, our adorable cockatiel. Cookie
                has free reign in the office and we all love a quick visit even
                if he sometimes pecks at our keybJUB8R87F8oards!
              </MascotP>
            </div>
            <div>
              <MascotImage
                src="https://cdn.cardcash.com/website/ui/about/mascot.png"
                alt=""
              />
            </div>
          </MascotContent>
        </MascotSection>
      </div>
    </div>
  );
};

export default AboutUs;
